import { render, staticRenderFns } from "./dlgUKey.vue?vue&type=template&id=3bff5453&"
import script from "./dlgUKey.vue?vue&type=script&lang=js&"
export * from "./dlgUKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports